<template>
  <div>
    <div>
      <a-select style="width: 300px" @change="val => handleChange(val)">
        <a-select-option
          :value="option.value"
          v-for="(option, index) in avatarOptions"
          :key="index"
        >
          {{ option.label }}
        </a-select-option>
      </a-select>
    </div>
  </div>
</template>
<script>
export default {
  name: "avatarDropDownPage",
  data() {
    return {
      val: null
    };
  },
  props: {
    avatarOptions: Array || Object,
    handleOptionType: Function
  },

  methods: {
    handleChange(value) {
      console.log(value, this.$props);
      this.handleOptionType(value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modals/userAvatarDropDown.vue